// extracted by mini-css-extract-plugin
export default {"container":"GadgetIOFormatContainer_container__QnufT","ioFormatContainer":"GadgetIOFormatContainer_ioFormatContainer__84Osz"};